import React from 'react';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import FadeIn from 'components/Transitions/FadeIn';
import { useTranslation } from 'react-i18next';
import Rocket from 'assets/rocket.png';

export function Bienvenue() {
  const { t } = useTranslation(['onboarding']);

  return (
    <StepWrapper
      title={t('onboarding:welcome.title')}
      currentStep="bienvenue"
      nextLabel={t('onboarding:welcome.cta')}
      centerVertically
      centerTitle
      presentationSlice
      subtitle={
        <FadeIn>
          <div tw="-mt-2 text-balance">{t('onboarding:welcome.subtitle')}</div>
        </FadeIn>
      }
      header={
        <div tw="pt-4 flex justify-center">
          <img tw="size-20" src={Rocket} />
        </div>
      }
    />
  );
}
